import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with 23h 27m 35s in seconds
  const initialTime = 23 * 3600 + 27 * 60 + 35;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-bold font-serif text-red-600" data-id="element-72">
      <div className="bg-cream-light px-3 py-2 rounded-lg shadow-sm border border-cream-dark" data-id="element-73">
        {formatTime(hours)}
        <span className="text-sm md:text-lg ml-1 text-carbon-lighter" data-id="element-74">hs</span>
      </div>
      <span className="text-brand-green" data-id="element-75">:</span>
      <div className="bg-cream-light px-3 py-2 rounded-lg shadow-sm border border-cream-dark" data-id="element-76">
        {formatTime(minutes)}
        <span className="text-sm md:text-lg ml-1 text-carbon-lighter" data-id="element-77">min</span>
      </div>
      <span className="text-brand-green" data-id="element-78">:</span>
      <div className="bg-cream-light px-3 py-2 rounded-lg shadow-sm border border-cream-dark" data-id="element-79">
        {formatTime(seconds)}
        <span className="text-sm md:text-lg ml-1 text-carbon-lighter" data-id="element-80">seg</span>
      </div>
    </div>;
}